import { apiClient } from "./apiClient";

export default {
  search(searchText) {
    return apiClient.get(`/rest/global_search?search=${searchText}`);
  },
  getSearchHistory() {
    return apiClient.get(`/rest/search_history`);
  },
};
